<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <imageVue :data-list="main.data"></imageVue>
      </template>
    </mainVue>
  </div>
</template>

<script>

  import mainVue from '../../../components/resource/main.vue'
  import imageVue from '../../../components/resource/image.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      imageVue, mainVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
